import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { SecondaryButton } from "../../components/buttons/SecondaryButton";
import Header from "../../components/layout/Header";
import { Page, PageBody, PageHeader } from "../../components/layout/Page";
import { backArrow, save, trash } from "../../assets/icons";
import Card from "../../components/card/Card";
import "./client.css";
import { TextInput } from "../../components/inputs/TextInput";
import { useEffect, useState } from "react";
import { Data } from "../../lib/typeDeclarations";
import { pattern } from "../../lib/pattern";
import { createRecord, deleteRecord, updateRecord } from "../../server/fetchFunctions";
import { useFindById, useListRecords } from "../../server/hooks/getData";
import { Loader } from "../../components/loader/Loader";

export default function EditClient() {
  document.title = "Ügyfél szerkesztése";
  const navigate = useNavigate();
  const id = useParams().id || "";

  const { data: initClient, loading: clientL } = useFindById("clients", [id], id);
  const { data: contacts, loading: contactsL } = useListRecords("contacts", [], { client_id: id });
  const { data: devices, loading: deviceL } = useListRecords("clientDevices", [], {
    client_id: id
  });
  const [isLoading, setIsLoading] = useState(true);

  const [client, setClinet] = useState<Data>({
    name: "",
    vat: "",
    zip: "",
    city: "",
    street: ""
  });
  const [devicesData, setDevicesData] = useState<Data[]>([]);
  const [contactsData, setContactsData] = useState<Data[]>([]);
  const [newContact, setNewContact] = useState<Data>({
    name: "",
    phone: "",
    email: ""
  });

  useEffect(() => {
    if (!clientL && !contactsL && !deviceL) {
      setIsLoading(true);
      setClinet(initClient);
      setContactsData(contacts.data);
      setDevicesData(devices.data);
      setIsLoading(false);
    }
  }, [contacts.data, devices.data, initClient]);

  //Functions
  const handleChange = (
    index: number,
    property: string,
    value: any,
    setState: React.Dispatch<React.SetStateAction<any>>,
    formatFunc?: (str: string) => void
  ) => {
    setState((prev: any[]) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              [property]: formatFunc ? formatFunc(value.target.value) : value.target.value
            }
          : item
      )
    );
  };

  const addNewContact = async () => {
    setIsLoading(true);
    const response = await createRecord("contacts", { ...newContact, client_id: id });
    contacts.data.push(response);
    setNewContact({ name: "", phone: "", email: "" });
    setIsLoading(false);
  };

  const updateContact = async (id: any, index: any) => {
    setIsLoading(true);
    const response = await updateRecord("contacts", id, contactsData[index]);
    contacts.data[index] = response;
    setIsLoading(false);
  };

  const updateClient = async () => {
    setIsLoading(true);
    await updateRecord("clients", id, client);
    setIsLoading(false);
  };

  const updateDevice = async (id: any, index: any) => {
    setIsLoading(true);
    const response = await updateRecord("clientDevices", id, devicesData[index]);
    devices.data[index] = response;
    setIsLoading(false);
  };

  const deleteDevice = async (id: any, index: any) => {
    setIsLoading(true);
    const response = await deleteRecord("clientDevices", id);
    // devices.data[index] = response;
    setIsLoading(false);
  };

  return (
    <Page>
      <Header>
        <SecondaryButton btn={{ svgBefore: backArrow, text: "Vissza", onClick: () => navigate(-1) }} />
        <PrimaryButton btn={{ svgBefore: save, text: "Ment", onClick: updateClient }} />
      </Header>
      <PageHeader title="Ügyfél szerkesztése" />
      {isLoading ? (
        <Loader />
      ) : (
        <PageBody>
          <div className="client">
            <div className="col-1">
              <Card title="Ügyfél">
                <TextInput
                  stateKey="name"
                  inlineLabel="Név"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />
                <TextInput
                  stateKey="vat"
                  inlineLabel="Adószám"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.vat}
                  labelWidth={170}
                  format="toVatnumber"
                />
                <TextInput
                  stateKey="zip"
                  inlineLabel="Ir. szám"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.zip}
                  labelWidth={170}
                  required
                  format="toInteger"
                />
                <TextInput
                  stateKey="city"
                  inlineLabel="Település"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />
                <TextInput
                  stateKey="street"
                  inlineLabel="Közterület"
                  state={client}
                  setState={setClinet}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />
              </Card>
              <p style={{ marginBottom: 10 }}>Eszközök</p>
              {devicesData.map((item, index) => (
                <Card key={item.id}>
                  <TextInput
                    stateKey="type"
                    inlineLabel="Típus"
                    state={devicesData[index]}
                    setState={setDevicesData}
                    labelWidth={170}
                    readonly
                  />
                  <TextInput
                    stateKey="manufacturer"
                    inlineLabel="Gyártó"
                    state={devicesData[index]}
                    setState={setDevicesData}
                    labelWidth={170}
                    readonly
                  />
                  <TextInput
                    stateKey="description"
                    inlineLabel="Megnevezés"
                    state={devicesData[index]}
                    setState={setDevicesData}
                    labelWidth={170}
                    readonly
                  />
                  <TextInput
                    stateKey="serial_no"
                    inlineLabel="Gyári szám"
                    state={devicesData[index]}
                    setState={setDevicesData}
                    itemOfArr={devicesData[index]}
                    labelWidth={170}
                    required
                  />
                  <SecondaryButton
                    btn={{
                      svgBefore: trash,
                      text: "Töröl",
                      onClick: () => deleteDevice(item.id, index)
                    }}
                  />
                  {JSON.stringify(devices.data[index]) !== JSON.stringify(devicesData[index]) && (
                    <SecondaryButton
                      btn={{
                        svgBefore: save,
                        text: "Ment",
                        onClick: () => updateDevice(item.id, index)
                      }}
                    />
                  )}
                </Card>
              ))}
            </div>
            <div className="col-2">
              <Card title="Kapcsolattartók">
                <TextInput
                  stateKey="name"
                  inlineLabel="Név"
                  state={newContact}
                  setState={setNewContact}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />
                <TextInput
                  stateKey="phone"
                  inlineLabel="Telefon"
                  state={newContact}
                  setState={setNewContact}
                  pattern={pattern.phone}
                  labelWidth={170}
                  format="toPhoneNumber"
                  required
                />
                <TextInput
                  type="email"
                  stateKey="email"
                  inlineLabel="E-mail"
                  state={newContact}
                  setState={setNewContact}
                  pattern={pattern.email}
                  labelWidth={170}
                  required
                />
                <SecondaryButton
                  btn={{
                    text: "Hozzáad",
                    onClick: addNewContact
                  }}
                />
              </Card>
              {contactsData.map((item, index) => (
                <Card key={item.id}>
                  <TextInput
                    stateKey="name"
                    inlineLabel="Név"
                    state={contactsData[index]}
                    setState={setContactsData}
                    itemOfArr={contactsData[index]}
                    pattern={pattern.normal_text}
                    labelWidth={170}
                    required
                  />
                  <TextInput
                    stateKey="phone"
                    inlineLabel="Telefon"
                    state={contactsData[index]}
                    setState={setContactsData}
                    itemOfArr={contactsData[index]}
                    pattern={pattern.phone}
                    labelWidth={170}
                    format="toPhoneNumber"
                    required
                  />
                  <TextInput
                    type="email"
                    stateKey="email"
                    inlineLabel="E-mail"
                    state={contactsData[index]}
                    setState={setContactsData}
                    itemOfArr={contactsData[index]}
                    pattern={pattern.email}
                    labelWidth={170}
                    required
                  />

                  {JSON.stringify(contacts.data[index]) !== JSON.stringify(contactsData[index]) && (
                    <SecondaryButton
                      btn={{
                        svgBefore: save,
                        text: "Ment",
                        onClick: () => updateContact(item.id, index)
                      }}
                    />
                  )}
                </Card>
              ))}
            </div>
          </div>
        </PageBody>
      )}
    </Page>
  );
}
